"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_85_2_0 = void 0;
/**
 * rename  gesamtschirm -> shielding
 * map shielding and twistedPair to new enums
 */
const migration_85_2_0 = (json) => {
    if (json.LeitungFilterProperties) {
        // twistedPair: boolean --> twistedPair:LeitungSelectionTwistedPairOptions
        if (json.LeitungFilterProperties.twistedPair === true) {
            json.LeitungFilterProperties.twistedPair = 'onlyTwistedPair';
        }
        if (json.LeitungFilterProperties.twistedPair == null) {
            json.LeitungFilterProperties.twistedPair = 'all';
        }
        // gesamtschirm --> shielding
        if (json.LeitungFilterProperties.gesamtschirm === true) {
            json.LeitungFilterProperties.shielding = 'shielded';
        }
        if (json.LeitungFilterProperties.gesamtschirm === false) {
            json.LeitungFilterProperties.shielding = 'unshielded';
        }
        if (json.LeitungFilterProperties.gesamtschirm == null) {
            json.LeitungFilterProperties.shielding = 'all';
        }
        delete json.LeitungFilterProperties.gesamtschirm;
    }
    return json;
};
exports.migration_85_2_0 = migration_85_2_0;
//# sourceMappingURL=migration_85_2_0.js.map